module.exports = __webpack_public_path__ + "media/images/spotify_attribution-9706de0876e4564007ffa70986b3ee3b.png";